<div class="range-slider">
  <div class="header">
    <ng-container *ngIf="isDual; else singleHeader">
      <span>Price Range</span>
      <strong>{{ format(currentMin) }} — {{ format(currentMax) }}</strong>
    </ng-container>
    <ng-template #singleHeader>
      <span>Distance Away</span>
      <strong>{{ format(currentSingle) }}</strong>
    </ng-template>
  </div>

 <div class="labels">
  <span>{{ format(isDual ? currentMin : currentSingle) }}</span>
  <span>{{ format(isDual ? currentMax : max) }}</span>
</div>

  <div class="track-container">
    <div class="track">
      <div class="track-bg"></div>

      <div class="fill"
           [style.left.%]="isDual ? minPercent : 0"
           [style.width.%]="isDual ? (maxPercent - minPercent) : singlePercent">
      </div>

      <!-- Single thumb -->
      <div *ngIf="!isDual" class="thumb" [style.left.%]="singlePercent"></div>

      <!-- Dual thumbs -->
      <div *ngIf="isDual" class="thumb min-thumb" [style.left.%]="minPercent"></div>
      <div *ngIf="isDual" class="thumb max-thumb" [style.left.%]="maxPercent"></div>

      <!-- Real range inputs – use (input) for live updates -->
      <input *ngIf="!isDual"
             type="range"
             class="input-layer"
             [min]="min" [max]="max" [step]="step"
             [value]="currentSingle"
             (input)="onSingleDrag($event)">

      <input *ngIf="isDual"
             type="range" class="input-layer min-input"
             [min]="min" [max]="max" [step]="step"
             [value]="currentMin"
             (input)="onMinDrag($event)">

      <input *ngIf="isDual"
             type="range" class="input-layer max-input"
             [min]="min" [max]="max" [step]="step"
             [value]="currentMax"
             (input)="onMaxDrag($event)">
    </div>
  </div>
</div>